var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-menu",
    clipPath: "url(#clip0_5121_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 10.1597L3.07566 16.0804C2.92432 16.2351 2.71455 16.3192 2.49861 16.3121C2.17115 16.3094 1.87731 16.1113 1.75163 15.8097C1.62507 15.5072 1.69145 15.1596 1.91979 14.9252L7.84413 9.00455L1.91979 3.08389C1.76491 2.93265 1.68082 2.72301 1.68791 2.5072C1.6826 2.2905 1.76668 2.08177 1.91979 1.92874C2.07289 1.77572 2.28178 1.6917 2.4986 1.69702C2.71455 1.68994 2.92431 1.77397 3.07565 1.92874L9 7.8494L14.9243 1.92874C15.1562 1.69346 15.5085 1.6227 15.8138 1.75008C16.1183 1.87745 16.3156 2.1764 16.3121 2.50721C16.3192 2.72303 16.2351 2.93265 16.0802 3.0839L10.1559 9.00456L16.0802 14.9252C16.3811 15.2472 16.3732 15.7496 16.0607 16.0609C15.7492 16.3731 15.2465 16.3811 14.9244 16.0804L9 10.1597Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5121_1644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClose);
export default __webpack_public_path__ + "static/media/icn_close.75c23fbda80dc8ec7a2d2d360033ea93.svg";
export { ForwardRef as ReactComponent };